import { useMeeting } from '../meeting/meetingProviderContextDef';
import { useEffect } from 'react';
import { eventEmitter, events } from '../utils';

/**
 *
 * @param {{
 *  onTranslationStateChanged?: Function,
 *  onTranslationLanguageChanged?: Function,
 *  onTranslationText?: Function,
 * }} options
 * @returns {{
 *  startTranslation: ( data: Object ) => Promise<void>
 *  changeTranslationLanguage: ( data: String ) => Promise<void>
 *  stopTranslation: () => Promise<void>
 * }}
 */
const useTranslation = ({
  onTranslationStateChanged = async () => {},
  onTranslationLanguageChanged = async () => {},
  onTranslationText = async () => {}
} = {}) => {
  const mMeeting = useMeeting();

  useEffect(() => {
    eventEmitter.on(
      events['translation-state-changed'],
      onTranslationStateChanged
    );

    eventEmitter.on(
      events['translation-language-changed'],
      onTranslationLanguageChanged
    );

    eventEmitter.on(events['translation-text'], onTranslationText);

    // off event listeners
    return () => {
      eventEmitter.off(
        events['translation-state-changed'],
        onTranslationStateChanged
      );
      eventEmitter.off(
        events['translation-language-changed'],
        onTranslationLanguageChanged
      );
      eventEmitter.off(events['translation-text'], onTranslationText);
    };
  }, []);

  /**
   * @param {{webhookUrl?:string, modelConfig?:any}} config?
   */
  const startTranslation = async config => {
    return mMeeting.meeting.startTranslation(config);
  };

  const changeTranslationLanguage = async language => {
    return mMeeting.meeting.changeTranslationLanguage(language);
  };

  const stopTranslation = async () => {
    return mMeeting.meeting.stopTranslation();
  };

  return { startTranslation, changeTranslationLanguage, stopTranslation };
};

export default useTranslation;
